import { Typography } from "@material-ui/core";
import { Monitoring } from "app/models/monitoring";
import { Pacient } from "app/models/pacient";
import React from "react";
import {
  FormattedMessage,
  injectIntl,
  WrappedComponentProps,
} from "react-intl";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import { Spinner } from "react-bootstrap";

interface PatientMonitoringCardViewProps {
  patient: Pacient;
  monitoring: Monitoring | null;
  loading?: boolean;
}

function PatientMonitoringCardView({
  patient,
  monitoring,
  loading = false,
}: PatientMonitoringCardViewProps & WrappedComponentProps) {
  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            color: "#007896",
          }}
        >
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          <Typography variant="h5" style={{ marginTop: 10, color: "#007896" }}>
            {patient.name}
          </Typography>
          <Typography variant="body1" style={{ color: "#948d8d" }}>
            Monitoramento
          </Typography>
          {monitoring ? (
            <>
              <Typography variant="body1" style={{ marginTop: 15 }}>
                Data de Início:{" "}
                <strong>{new Date(monitoring.checkin).toLocaleString()}</strong>
              </Typography>
              <Typography variant="body1">
                Localização:{" "}
                <strong>{patient.location || "Não Informado"}</strong>
              </Typography>
              <Typography variant="body1">
                Decúbitos Permitidos:{" "}
                <span style={{ color: "green", fontWeight: "bold" }}>
                  {monitoring.allowedPositions?.join(", ")}
                </span>
              </Typography>
              <a
                href={`/monitoring/sector/${monitoring.sectorId}?monitoringId=${monitoring.id}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "block",
                  marginTop: 20,
                  color: "#007896",
                  border: "1px solid #007896",
                  textAlign: "center",
                  padding: "0.5rem",
                  borderRadius: 10,
                }}
              >
                Ver Monitoramento Completo <OpenInNewIcon />
              </a>
            </>
          ) : (
            <Typography variant="body1" style={{ marginTop: 15 }}>
              Este{" "}
              <FormattedMessage id="PATIENTS.NOMENCLATURE.SINGULAR.LOWER_CASE" />{" "}
              <span style={{ color: "red", fontWeight: 500 }}>
                não está sendo monitorado
              </span>{" "}
              no momento.
            </Typography>
          )}
        </>
      )}
    </div>
  );
}

export default injectIntl(PatientMonitoringCardView);
